export default {
  settings: state => state.settings,
};
